import React from "react";
import { connect } from "react-redux";
import Plyr from "react-plyr";
import { Row, Col } from "react-bootstrap";

const XferAudioPlayer = ({ previews }) => {
  // Only render if there are previews
  if (!previews || previews.length === 0) {
    return null;
  }

  const last_preview = previews[previews.length - 1];
  
  return (
    <div className="audio-player-container">
      <div className="fixed-bottom xfer-player">
        <Row>
          <Col xs={1} className="d-none d-sm-block">
            <img 
              className="preview-image" 
              src={last_preview.image} 
              alt={last_preview.name} 
            />
          </Col>
          <Col xs={11}>
            <div className="player">
              <Plyr 
                type="audio"
                url={last_preview.preview}
                autoplay
              />
            </div>

            <div className="preview-description">
              <h4>{last_preview.name}</h4>
              <p>{last_preview.manufacturer_name}</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  previews: state.previews
});

export default connect(mapStateToProps)(XferAudioPlayer);
